import { render } from "./SwayReporting.vue?vue&type=template&id=6f5db054"
import script from "./SwayReporting.vue?vue&type=script&lang=js"
export * from "./SwayReporting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__